import TruncateText from '@creditflowresearch/uilib/TruncateText';
import type { IBondScreenerIssuer } from '@/creditflowresearch/domain/vo/Bondscreener';

interface IIssuerCellProps {
  value: IBondScreenerIssuer[] | null | undefined,
}

const IssuersListCell = ({ value }: IIssuerCellProps) => {
  if (!value?.length) {
    return (<>-</>);
  }

  const formatIssuer = (issuer: IBondScreenerIssuer) =>
    issuer.ticker ? `${ issuer.name } (${ issuer.ticker })` : issuer.name;

  const display = value.map((i) => i.name).join(', ');
  const tooltip = value.map(formatIssuer).join(', ');

  return (
    <TruncateText value={ tooltip } shouldShowTooltip>
      { display }
    </TruncateText>
  );
};

export default IssuersListCell;
